import './customDataTable.css'

import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Menu } from 'primereact/menu'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CurrentAccount, UserRole } from 'types/Organization'
import { TableConfig } from 'types/TableHeader'

import { TableContainer, TableWrapper } from './customDataTable.style'

interface Props {
    tableConfig: TableConfig
    currentAccount: CurrentAccount
    data: any[]
    onEdit: (rowData: any) => void
    onDelete: (rowId: any) => void
    showDeleteDialog: (onDelete: () => void) => void // added
}

export const CustomDataTable: React.FC<Props> = ({ tableConfig, currentAccount, data, onEdit, onDelete, showDeleteDialog }) => {
    const [selectedRow, setSelectedRow] = React.useState<any>(null)
    const actionMenuRef = React.useRef<any>(null)
    const navigate = useNavigate()

    const showMenu = (event: React.MouseEvent<HTMLButtonElement>, rowData: any) => {
        setSelectedRow(rowData)
        if (actionMenuRef.current) {
            actionMenuRef.current.toggle(event)
        }
    }

    const actionTemplate = (rowData: any) => {
        const isCurrentUser = currentAccount.orgId === selectedRow?.org_id
        const isCurrentUserOrSuperAdmin = currentAccount.orgId === selectedRow?.org_id || currentAccount.role === UserRole.superAdmin
        const SuperAdminAndNotCurrentUser = currentAccount.orgId !== selectedRow?.org_id && currentAccount.role === UserRole.superAdmin
        const isOrganizationsPage = tableConfig.titleRow.title === 'Szervezetek'

        const menuModel = []

        if (isOrganizationsPage && SuperAdminAndNotCurrentUser) {
            menuModel.push(
                {
                    label: 'Helyszínek',
                    icon: 'pi pi-map-marker',
                    command: () => {
                        navigate(`/admin/helyszinek/szervezet/${selectedRow?.org_id}`)
                    },
                },
                {
                    label: 'Műsor',
                    icon: 'pi pi-star',
                    command: () => {
                        navigate(`/admin/musor/szervezet/${selectedRow?.org_id}`)
                    },
                },
                {
                    label: 'Események',
                    icon: 'pi pi-calendar',
                    command: () => {
                        navigate(`/admin/esemenyek/szervezet/${selectedRow?.org_id}`)
                    },
                },
            )
        }

        if (isCurrentUserOrSuperAdmin) {
            menuModel.push({
                label: 'Szerkesztés',
                icon: 'pi pi-pencil',
                command: () => {
                    onEdit(selectedRow)
                },
            })
        }
        if ((isOrganizationsPage && SuperAdminAndNotCurrentUser) || (!isOrganizationsPage && isCurrentUser)) {
            menuModel.push({
                label: 'Törlés',
                icon: 'pi pi-trash',
                command: () => {
                    showDeleteDialog(() => onDelete(selectedRow[tableConfig.idName]))
                },
            })
        }

        return (
            <div className="action-menu">
                <Menu model={menuModel} popup ref={actionMenuRef} />
                <Button icon="pi pi-ellipsis-h" style={{ color: '#000' }} severity="secondary" text onClick={(e) => showMenu(e, rowData)} />
            </div>
        )
    }

    const nameTemplate = (rowData: any) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {rowData.color && (
                    <div
                        style={{
                            width: '21px',
                            height: '21px',
                            borderRadius: '50%',
                            backgroundColor: rowData.color,
                            marginRight: '8px',
                        }}
                    ></div>
                )}
                <span>{rowData.name}</span>
            </div>
        )
    }

    return (
        <TableContainer>
            <TableWrapper>
                {data && data.length > 0 ? (
                    <DataTable value={data} stripedRows style={{ width: '100%' }}>
                        {tableConfig.headers.map((header, index) => (
                            <Column
                                key={index}
                                field={header.field}
                                header={header.title}
                                body={header.field === 'name' ? nameTemplate : undefined}
                                bodyStyle={{ textAlign: header.align }}
                                headerStyle={{ textAlign: header.align }}
                                headerClassName="dataTableHeader"
                                sortable={header.sortable}
                            />
                        ))}
                        <Column
                            key="actions"
                            header="Művelet"
                            body={actionTemplate}
                            style={{ textAlign: 'center', width: '7rem' }}
                            headerClassName="dataTableHeader"
                        />
                    </DataTable>
                ) : (
                    <p>No data available.</p>
                )}
            </TableWrapper>
        </TableContainer>
    )
}
